import { CUSTOM_TEMPLATES } from "../../constants/api-constants";
import { CAMPAIGNS_TEMPLATES_PAGE } from '../../constants/constants';
import httpClient from "../../utils/http-client";

export const getCustomTemplates = (shopId: string) => {
    return httpClient.get(CUSTOM_TEMPLATES.replace('$shopId', shopId));
}

export const createCustomTemplates = (shopId: string, params: any) => {
    return httpClient.post(`${CUSTOM_TEMPLATES.replace('$shopId', shopId)}/create`, params);
}

export const addCustomTemplateMedia = (shopId: string, params: any) => {
    return httpClient.post(`${CUSTOM_TEMPLATES.replace('$shopId', shopId)}/upload`, params);
}

export const deleteCustomTemplates = (shopId: string, templateId: string) => {
    return httpClient.delete(`${CUSTOM_TEMPLATES.replace('$shopId', shopId)}/${templateId}`)
}